var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"pages","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Large-Desktop","transform":"translate(-1387.000000, -2502.000000)","fill":"currentColor"},React.createElement("g",{"id":"Group-21","transform":"translate(1391.500000, 2513.500000) scale(-1, 1) translate(-1391.500000, -2513.500000) translate(1370.000000, 2492.000000)"},React.createElement("g",{"id":"Group-20"},React.createElement("polygon",{"id":"Fill-1","transform":"translate(19.260500, 21.526500) scale(-1, 1) translate(-19.260500, -21.526500) ","points":"14.436 10 13 11.391 22.753 21.456 13.101 31.679 14.556 33.053 25.521 21.439"}))))));
}

RightArrow.defaultProps = {"width":"13px","height":"23px","viewBox":"0 0 13 23","version":"1.1"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
